import { render, staticRenderFns } from "./InfinityChallengesTab.vue?vue&type=template&id=e3a1daec&scoped=true"
import script from "./InfinityChallengesTab.vue?vue&type=script&lang=js"
export * from "./InfinityChallengesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a1daec",
  null
  
)

export default component.exports